export const GET_IMMEDIATE_BOSS='GET_IMMEDIATE_BOSS';
export const LOADING_IMMEDIATE_BOSS='LOADING_IMMEDIATE_BOSS';
export const SAVE_LOADING_IMMEDIATE_BOSS='SAVE_LOADING_IMMEDIATE_BOSS';